import React from "react";

const HOURS = [
  { day: "Monday", time: "4:00 PM — Midnight" },
  { day: "Tuesday", time: "4:00 PM — Midnight" },
  { day: "Wednesday", time: "4:00 PM — Midnight" },
  { day: "Thursday", time: "4:00 PM — 2:00 AM" },
  { day: "Friday", time: "4:00 PM — 3:00 AM" },
  { day: "Saturday", time: "4:00 PM — 3:00 AM" },
  { day: "Sunday", time: "4:00 PM — 2:00 AM" },
];

export default function OpeningHours({ onBook }) {
  return (
    <section id="hours" data-testid="hours-section" className="relative py-24 md:py-32 bg-neutral-950">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5">
          <p className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-4">Hours of Service</p>
          <h2 className="font-serif font-light text-white text-4xl md:text-5xl lg:text-6xl tracking-tight leading-tight">
            Open <span className="italic text-[#D4AF37]">seven nights</span> a week
          </h2>
          <p className="mt-8 text-neutral-400 leading-relaxed max-w-md">
            For private events and full buy-outs, get in touch — we'll tailor the room around your evening.
          </p>
          <button
            onClick={onBook}
            data-testid="hours-book-btn"
            className="mt-10 inline-flex items-center gap-3 border border-[#D4AF37] text-[#D4AF37] font-medium tracking-[0.2em] uppercase text-xs py-4 px-8 hover:bg-[#D4AF37] hover:text-black transition-colors"
          >
            Plan a Private Event
          </button>
        </div>
        <div className="lg:col-span-7">
          <ul className="divide-y divide-neutral-800 border-t border-neutral-800">
            {HOURS.map((h) => (
              <li key={h.day} className="flex items-center justify-between py-6 group" data-testid={`hours-row-${h.day.toLowerCase()}`}>
                <span className="font-serif text-2xl md:text-3xl text-white tracking-tight">{h.day}</span>
                <span className="text-sm md:text-base text-neutral-300 tracking-wider group-hover:text-[#D4AF37] transition-colors">{h.time}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
